<div class="placeholder-glow">
  <span *ngFor="let _ of [].constructor(rows)" class="placeholder" [ngClass]="['placeholder', 'col-' + width]"></span>
</div>
